import { createAction } from '@reduxjs/toolkit';
import { sendBlockBannerAnalytics, sendInfoCardClickAnalytics } from "../../blocks/analytics";
import { getAnalyticEventType } from "../blocks/selectors";
import { BANNER_BLOCK_EVENT, INFO_BLOCK_TYPE } from "../blocks/infoCards/constants";
import { openFloatingPhone } from "../FloatingPhone/actions";
export var closeInfoCard = createAction('CLOSE_INFO_CARD');
export var openInfoCard = createAction('OPEN_INFO_CARD');
export var setCurrentInfoBanner = createAction('SET_CURRENT_CARD');
export var setPopupStep = createAction('SET_POPUP_STEP');
export var openInfoCardModalAnalytics = function openInfoCardModalAnalytics(type, cardName, href) {
  return function (dispatch, getState) {
    var pageType = getAnalyticEventType(getState());
    sendInfoCardClickAnalytics(pageType, cardName);
    if (type === INFO_BLOCK_TYPE.login) {
      window.location.href = href;
      return;
    }
    if (type === INFO_BLOCK_TYPE.move) {
      window.location.href = href;
      return;
    }
    dispatch(openInfoCard(type));
  };
};
export var onButtonClickBannerBlock = function onButtonClickBannerBlock(_ref) {
  var index = _ref.index,
    link = _ref.link,
    pageType = _ref.pageType,
    title = _ref.title;
  return function (dispatch) {
    var currentBanner = index + 1;
    sendBlockBannerAnalytics({
      event: BANNER_BLOCK_EVENT.click,
      id: currentBanner,
      name: title,
      pageType: pageType,
      url: link
    });
    if (link) return;
    dispatch(openFloatingPhone());
  };
};